import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CSSProperties, ThemeColors, useTheme } from 'styled-components';
import Flex from './Flex';

type IconProps = {
    icon: IconDefinition;
    iconColor?: keyof ThemeColors;
    small?: boolean;
    size?: string;
    style?: CSSProperties;
    className?: string;
};

const getSize = (small?: boolean, size?: any) => {
    if (size) return size;

    return small ? '1x' : '2x';
};

const IconHeader: React.FC<IconProps> = ({ icon, iconColor, small, size, style, ...props }) => {
    const theme = useTheme();

    return (
        <Flex align="center" justify="center">
            <FontAwesomeIcon
                style={style}
                size={getSize(small, size)}
                icon={icon}
                color={iconColor ? theme.colors[iconColor] : theme.colors.accent}
                {...props}
            />
        </Flex>
    );
};

export default IconHeader;
